// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Snotify, {SnotifyPosition} from 'vue-snotify/vue-snotify.min.js'
import BootstrapVue from 'bootstrap-vue'
import VeeValidate from 'vee-validate'
import App from './App'
import store from './store'
import router from './router'
import {sync} from 'vuex-router-sync'
import VuesticPlugin from 'src/components/vuestic-components/vuestic-components-plugin'
import moment from 'moment'
import Api from './services/api'

Vue.use(VuesticPlugin)
Vue.use(BootstrapVue)

// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, {fieldsBagName: 'formFields'})

Vue.use(Snotify)

sync(store, router)

let mediaHandler = () => {
  if (window.matchMedia(store.getters.config.windowMatchSizeLg).matches) {
    store.dispatch('toggleSidebar', true)
  } else {
    store.dispatch('toggleSidebar', false)
  }
}

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)

  if (to.name !== 'Login' && !Api.user.authenticated) return next({path: '/auth/login'});
  if (to.name === 'Login' && Api.user.authenticated) return next({path: '/dashboard'});

  next()
})

router.afterEach((to, from) => {
  mediaHandler()
  store.commit('setLoading', false)
})


window.Vue = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})


Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY HH:mm')
  }
})



// WEBPACK FOOTER //
// ./src/main.js